import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Tooltip, Switch, Button } from 'antd';

import { IconEdit } from '../../../../data/assets/icons';

export default class EditablePageHeader extends Component {
    constructor() {
        super();
        this.state = {
            is_title_editing: false,
        };
    }

    moveCaretAtEnd = (e) => {
        let temp_value = e.target.value;
        e.target.value = '';
        e.target.value = temp_value;
    };

    startTitleEditing = () => {
        this.setState({ is_title_editing: true })
    };

    stopTitleEditing = () => {
        this.setState({ is_title_editing: false })
    };

    render() {
        const { editable, container_class, title, title_class, title_placeholder, edit_tooltip_title, onChangeTitle, show_switch, checked, checked_title, unchecked_title, onChangeSwitch, show_first_btn, first_btn_type, first_btn_text, onClickFirstBtn, show_btn, btn_loading, btn_text, btn_type, onClickBtn } = this.props;
        const { is_title_editing } = this.state;

        return (
            <div className={`ori-flex-row ori-flex-jsb ori-flex-wrap ori-tb-pad-15 ori-lr-pad-10 ori-overflow-hidden" ${container_class}`}>
                {
                    is_title_editing &&
                    <div className="ori-flex ori-lr-pad-5">
                        <Input autoFocus className={`ori-height-auto ori-font-default ori-no-pad ori-input-none ${title_class}`} placeholder={title_placeholder} value={title} onFocus={this.moveCaretAtEnd} onBlur={this.stopTitleEditing} onChange={onChangeTitle} />
                    </div>
                }
                {
                    !is_title_editing &&
                    <div className="ori-flex-row ori-lr-pad-5">
                        <div className={`ori-text-overflow-dotted ${title_class}`}>
                            <span>{title}</span>
                        </div>
                        {
                            editable &&
                            <div className="ori-flex-column ori-flex-jc ori-lr-pad-10">
                                <Tooltip placement="top" title={edit_tooltip_title}>
                                    <div className="ori-flex ori-pad-3 ori-cursor-ptr ori-border-radius-4 ori-bg-primary ori-font-white" onClick={this.startTitleEditing}>
                                        <IconEdit size={13} />
                                    </div>
                                </Tooltip>
                            </div>
                        }
                    </div>
                }
                <div className="ori-flex-row">
                    {
                        show_switch &&
                        <div className="ori-lr-mrgn-5">
                            <span className="ori-r-pad-10">{checked ? checked_title : unchecked_title}</span>
                            <Switch size="small" checked={checked} onChange={onChangeSwitch} />
                        </div>
                    }
                    {
                        show_first_btn &&
                        <Button type={first_btn_type} size="small" className="ori-lr-mrgn-5 ori-lr-pad-15 ori-border-radius-15" onClick={onClickFirstBtn} >{first_btn_text}</Button>
                    }
                    {
                        show_btn &&
                        <Button loading={btn_loading} type={btn_type} size="small" className="ori-lr-mrgn-5 ori-lr-pad-15 ori-border-radius-15" onClick={onClickBtn} >{btn_text}</Button>
                    }
                </div>
            </div>
        );
    }
}

EditablePageHeader.propTypes = {
    editable: PropTypes.bool,
    container_class: PropTypes.string,
    title: PropTypes.string,
    title_class: PropTypes.string,
    title_placeholder: PropTypes.string,
    edit_tooltip_title: PropTypes.string,
    onChangeTitle: PropTypes.func,
    show_switch: PropTypes.bool,
    checked: PropTypes.bool,
    checked_title: PropTypes.string,
    unchecked_title: PropTypes.string,
    onChangeSwitch: PropTypes.func,
    show_btn: PropTypes.bool,
    btn_loading: PropTypes.bool,
    btn_text: PropTypes.string,
    btn_type: PropTypes.string,
    onClickBtn: PropTypes.func,
    show_first_btn: PropTypes.bool,
    first_btn_type: PropTypes.string,
    first_btn_text: PropTypes.string,
    onClickFirstBtn: PropTypes.func,
};

EditablePageHeader.defaultProps = {
    editable: false,
    container_class: "ori-b-border-light",
    title: "title",
    title_class: "ori-font-18",
    title_placeholder: "Enter title",
    edit_tooltip_title: "Edit title",
    show_switch: false,
    checked_title: "Active",
    unchecked_title: "Inactive",
    show_btn: false,
    btn_loading: false,
    btn_text: 'Save',
    btn_type: 'primary',
    show_first_btn: false,
    first_btn_text: 'Cancel'
};


// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/editablepageheader/index.js